/**
 * 获取指定枚举元数据
 * @param {'总对象'} obj    this.$store.getters.enumMetadata
 * @param {'属性名'} key 
 * 
 * 使用方式：
 * import {getEnumMetaData} from "@/utils/getEnumMeta";
 * getEnumMetaData(this.$store.getters.enumMetadata,'CompanyType');
 * return [select组件需要的数组];
 */
export function getEnumMetaData(obj,key){
  let arr = [];
  for(let keys in obj[key]){
    arr.push({
      key: keys,
      value: obj[key][keys]
    });
  }
  return arr;
} 

export function getEnumMetaNameData(obj,key){
  let arr = [];
  for(let keys in obj[key]){
    arr.push({
      name: obj[key][keys],
      value: keys
    });
  }
  return arr;
} 

/**
 * 通过中文说明 获取指定枚举元数据的英文值
 * @param {'总对象'} obj    this.$store.getters.enumMetadata
 * @param {'属性名'} key
 * @param {'中文说明'} val
 * 
 * 使用方式：
 * import {getEnumMetaValue} from "@/utils/getEnumMeta";
 * getEnumMetaValue(this.$store.getters.enumMetadata,'CompanyStatus','已退出')
 * return 'Dropped';
 */
export function getEnumMetaValue(obj,key,val){
  for(let keys in obj[key]){
    if(obj[key][keys]==val){
      return keys;
    }
  }
} 

/**
 * 通过英文值 获取指定中文
 * @param {'总对象'} obj    this.$store.getters.enumMetadata
 * @param {'属性名'} key
 * @param {'英文'} val
 * 
 * 使用方式：
 * import {getEnumMetaValue} from "@/utils/getEnumMeta";
 * getEnumMetaValue(this.$store.getters.enumMetadata,'CompanyStatus','Dropped')
 * return '已退出';
 */
export function getEnumMetaKey(obj,key,val){
  for(let keys in obj[key]){
    if(keys==val){
      return obj[key][keys];
    }
  }
} 

/**
 * 通过英文值 获取选择配置项
 * @param {'总对象'} obj    this.$store.getters.enumMetadata
 * @param {'属性名'} name   'Deer.Customer.Collection.AttentionLevelType'
 * 
 * 使用方式：
 * import {getEnumValues} from "@/utils/getEnumMeta";
 * getEnumOptions(this.$store.getters.enumMetadata,'Deer.Customer.Collection.AttentionLevelType')
 * return ['男','女'];
 */
export function getEnumValues(obj, name) {
  let arr=[];
	obj.map(el=>{
		if (el.name==name) {
			el.value.map(item=>{
				arr.push(item.option)
			})
		}
	})
	return arr;
}
